import React from 'react'
import headerimg from '../assets/OWRB header.png'
import Videobtn from '../assets/Button - Video.png'
import Fivebtn from '../assets/5.png'
import Kiamichibtn from '../assets/Button - Kiamichi.png'
import AddiResource from '../components/AddiResource';
import Kiamichipdf from '../assets/pdf/Kiamichi.pdf'

export default function Kiamchi() {
    return (
        <div>

            <main className="flex-shrink-0 modular min-vh-100 mt-5">

                <img className='my-5' style={{ maxWidth: "100%" }} src={headerimg} />

                <div className="container mt-2">
                    <div className='row'>
                        <div className='col-1 d-none d-lg-block'></div>
                        <div className='col-12 col-lg-10'>
                            <div className="row col-12">

                                <div className="col-md-4 col-lg-2">
                                    <div className="row" style={{ paddingBottom: "10px" }}>
                                        <a href={Kiamichipdf} without rel="noopener noreferrer" target="_blank"><img
                                            src={Fivebtn} style={{ maxWidth: "100%" }} /></a>
                                    </div>
                                    <div className="row text-center" style={{ paddingBottom: "10px" }}>
                                        <a href="https://vimeo.com/503096608/c2e637fbe7" target="_blank"><img
                                            src={Videobtn} height="150" width="150"
                                            style={{ maxWidth: "100%" }} /></a>
                                    </div>
                                    <div className="row" style={{ paddingBottom: "10px" }}>
                                        <a href=" https://kiamichi.metroquest.com/" target="_blank"><img
                                            src={Kiamichibtn} style={{ maxWidth: "100%" }} /></a>
                                    </div>

                                </div>
                                <div className="col-md-8 col-lg-10">
                                    <div className="container" style={{ minHeight: "400px" }}>
                                        <div className="row">
                                            <div className="col" style={{ textAlign: "start" }}>
                                                <h1>Kiamichi</h1>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col" style={{ textAlign: "start" }}>
                                                <p>The Kiamichi watershed is approximately 1,820 square miles and is in the
                                                    southeast quadrant of Oklahoma. The watershed is horseshoe shaped and generally
                                                    follows along the U.S. Highway 271 corridor as it meanders through the Kiamichi
                                                    Mountains. The Kiamichi River generally drains from east to west until it
                                                    reaches Sardis Lake. At this point it begins to drain southerly down through
                                                    Hugo Lake until it reaches the confluence of the Red River.</p>
                                                <p>The watershed contains 15 communities, 10 of which participate in the National
                                                    Flood Insurance Program (NFIP), and includes the counties of Atoka, Choctaw,
                                                    Latimer, Le Flore, Pittsburg, and Pushmataha.</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col" style={{ textAlign: "start" }}>
                                                <p>On the left side of this screen, you will find two round blue buttons that you
                                                    can click on. The top button links to a Tutorial Video which explains how to
                                                    take the online interactive survey about your watershed. The lower button will
                                                    take you to the actual survey.</p>
                                                <p>At the bottom of the screen, you will find a slew of additional free resources
                                                    that cover topics such as Risk Mapping, National Flood Insurance Program, Dam
                                                    Safety, Hazard Mitigation Assistance Grants, a link to Oklahoma Water Resource
                                                    Board, and much more.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>
                        <div className='col-1'></div>
                    </div>
                </div>

            </main>
            <AddiResource />
        </div>
    )
}

